export default "__VITE_ASSET__b0e90116__"